/**
 * @fileoverview Dialog for submitting a call to action through create post
 *
 * @author Gil Walzer (gwalzer@yext.com)
 */
goog.module('yext.social.post.CallToActionDialog');
goog.module.declareLegacyNamespace();
const templates = goog.require('yext.templates');
const yext = goog.require('yext');
const Model = goog.require('yext.mvc.Model');
/**
 * @constructor
 * @param {function()} onSubmit
 */
const CallToActionDialog = function(onSubmit) {
  this.$context = $('.js-call-to-action-dialog');
  this.$customUrlSelector = this.$context.find('select.js-url-field-select');
  this.$callToActionSelector = this.$context.find('select.js-call-to-action-select');
  this.$urlContainer = this.$context.find('.js-url-container');
  this.$urlFieldTextInput = this.$context.find('.js-url-field-input');
  this.$customMessage = this.$context.find('.js-custom-message');
  this.$form = this.$context.find('.js-call-to-action-form');

  /**
  * @type {Model}
  * @private
  */
  this.model_ = new Model();

  /**
  * @type {!Object}
  * @private
  */
  this.originalState_ = null;

  if (!yext.isFunction(onSubmit)) {
    throw new TypeError('CallToActionDialog(): Invalid callback parameter, expected a Function');
  }
  this.onSubmit_ = onSubmit;

  this.init();
};

/**
 * Opens a dialog with the fields from a model parameter.
 *
 * @param {object<string, object>} callToAction
 * @public
 */
CallToActionDialog.prototype.openDialogFromModel = function(callToAction) {
  this.model_.set({
    'customFieldId': callToAction['customFieldId'],
    'urlField': callToAction['urlField'],
    'callToActionTypeId': callToAction['callToActionTypeId'],
    'callToActionName': callToAction['callToActionName'],
    'isEdit': true,
    'error': false,
  });
  this.buildTitle_();
  this.renderFromModel_();
  this.$context.dialog('open');
};

/**
 * Opens a dialog with default fields.
 * @public
 */
CallToActionDialog.prototype.openDialog = function() {
  this.$context.dialog('open');
};

/**
 * initializes the class
 * @private
 */
CallToActionDialog.prototype.init = function() {
  this.initModel_();
  this.initDialog_();
  this.bindInputToModel_();
  this.bindModelChangesToRender_();
  this.bindSubmit_();
  this.bindCancel_();
};

/**
 * Returns the name of the custom field for the given id
 * @param {number} customFieldId
 * @return {string} customFieldName
 */
CallToActionDialog.prototype.getCustomFieldName = function(customFieldId) {
  // TODO(hydra): handle custom fields which have been removed
  return this.$customUrlSelector.find('[value="' + customFieldId + '"]').text();
};

/**
 * Returns the name of the call to action type with the given id
 * @param {number} typeId
 * @param {string} typeName
 */
CallToActionDialog.prototype.getCallToActionTypeName = function(typeId) {
  return this.$callToActionSelector.find('[value="' + typeId + '"]').text();
};

/**
 * initializes the model
 * @private
 */
CallToActionDialog.prototype.initModel_ = function() {
  var customFieldId = parseInt(this.$customUrlSelector.val(), 10);
  this.model_.init({
    'callToActionTypeId': parseInt(this.$callToActionSelector.val(), 10),
    'urlField': null,
    'customFieldId': isNaN(customFieldId) ? null : customFieldId,
    'callToActionName': this.$callToActionSelector.find(':selected').text(),
    'isEdit': false,
    'error': false,
  });
  this.originalState_ = this.model_.raw();
};

/**
 * Initializes the dialog
 * @private
 */
CallToActionDialog.prototype.initDialog_ = function() {
  this.$context.dialog({
    autoOpen: false,
    dialogClass: 'call-to-action-dialog-container',
    draggable: false,
    modal: true,
    title: null,
    resizable: true,
    width: 519,
    close: function() {
      this.reset_();
    }.bind(this),
  });
  this.buildTitle_();
};

/**
 * Updates the model when the dialog inputs are changed
 */
CallToActionDialog.prototype.bindInputToModel_ = function() {
  var self = this;
  this.$callToActionSelector.on('change', function() {
    let ctaType = parseInt($(this).val(), 10);
    self.model_.set('callToActionTypeId', ctaType);
    self.model_.set('callToActionName', $(this).find(':selected').text());
    self.toggleUrlInput_(ctaType);
  });

  this.$customUrlSelector.on('change', function() {
    var fieldId = parseInt($(this).val(), 10);

    self.model_.set({
      'urlField': isNaN(fieldId) ? '' : $(this).find(':selected').text(),
      'customFieldId': isNaN(fieldId) ? null : fieldId,
    });
  });

  this.$urlFieldTextInput.on('change', function() {
    self.model_.set('urlField', $(this).val());
  });
};

/**
 * Shows/hides URL input, and displays custom messages for certain CTA types
 */
CallToActionDialog.prototype.toggleUrlInput_ = function(ctaType) {
  if (ctaType == CallToActionDialog.prototype.CALL_CTA_TYPE) {
    this.$urlContainer.hide();
    this.$context.find('.js-error').empty();
    this.$customMessage.html('The Call CTA will use the primary phone number on your Google listing.');
    this.$customMessage.show();
  } else {
    this.$urlContainer.show();
    this.$customMessage.hide();
  }
};

/**
 * Calls the private render function when the model receives change events
 * @private
 */
CallToActionDialog.prototype.bindModelChangesToRender_ = function() {
  this.model_.on('change, reset', function() {
    this.render_();
  }.bind(this));
};

CallToActionDialog.prototype.CALL_CTA_TYPE = 8;

/**
 * Binds the constructor onSubmit callback parameter to the submit button
 * @private
 */
CallToActionDialog.prototype.bindSubmit_ = function() {
  this.$form.on('submit', function(e) {
    this.model_.set('error', false);
    this.model_.set('actionError', false);
    var fieldId = this.model_.get('customFieldId');
    var urlField = this.model_.get('urlField');
    var customFieldId = this.model_.get('callToActionTypeId');
    if (fieldId == null
        && customFieldId != CallToActionDialog.prototype.CALL_CTA_TYPE
        && !yext.URL_REGEX.test(urlField)) {
      this.model_.set('error', true);
    }

    if (customFieldId == 1) {
      this.model_.set('actionError', true);
    }

    if (this.model_.get('error') || this.model_.get('actionError')) {
      return false;
    }

    e.preventDefault();
    e.stopPropagation();
    this.onSubmit_(jQuery.extend(true, {}, this.model_));
    this.closeDialog_();
  }.bind(this));
};

/**
 * @private
 */
CallToActionDialog.prototype.bindCancel_ = function() {
  this.$context.find('.js-cancel').on('click', function() {
    this.closeDialog_();
  }.bind(this));
};

/**
 * Closes the dialog
 * @private
 */
CallToActionDialog.prototype.closeDialog_ = function() {
  this.$context.dialog('close');
};

/**
 * Resets the dialog state
 * @private
 */
CallToActionDialog.prototype.reset_ = function() {
  this.model_.resetState(this.originalState_);
};

/**
 * Renders the dialog
 * @private
 */
CallToActionDialog.prototype.render_ = function() {
  this.renderFromModel_();
  var $error = this.$context.find('.js-error');
  $error.empty();
  if (this.model_.get('error')) {
    var error = yext.msg('Please enter a valid URL');
    $error.append(error);
  }

  if (this.model_.get('actionError')) {
    if (this.model_.get('error')) {
      $error.append('<br/>');
    }
    var error = yext.msg('Please select an action type');
    $error.append(error);
  }
};

/**
 * Renders the dialog from the model
 * @private
 */
CallToActionDialog.prototype.renderFromModel_ = function() {
  this.$urlFieldTextInput.val(this.model_.get('urlField'));
  var fieldId = this.model_.get('customFieldId');
  this.$customUrlSelector.val(fieldId).trigger('selectedOption');
  this.$callToActionSelector.val(this.model_.get('callToActionTypeId')).trigger('change');
  this.$urlFieldTextInput.prop('disabled', fieldId != null);
};

/**
 * Builds the title of the dialog.
 * @private
 */
CallToActionDialog.prototype.buildTitle_ = function() {
  var isEdit = this.model_.get('isEdit');
  var editMsg = yext.msg('Edit');
  var addMsg = yext.msg('Add');
  var callToActionMsg = yext.msg(' Call to Action');
  this.$context.dialog({closeText: ''});
  var requiredMsg = yext.msg('Required');
  var title = isEdit ? editMsg + callToActionMsg: addMsg + callToActionMsg;
  $('.call-to-action-dialog-container span.ui-dialog-title').html(`
    <div class="call-to-action-header-container">
      <div>${title}</div>
      <div class="required-container">
        ${requiredMsg} <span class="required-legend"><i class="required-circle"></i></span>
      </div>
    </div>`);
};

exports = CallToActionDialog;
